// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__a8D7q","loader":"Loader_loader__9E31l"};